<template>
  <Combobox
    v-if="!isLoading"
    :triggerLabel="name"
    :groups="tags"
    :showSearch="true"
    :showClear="true"
    :name="name"
    :handle="handle"
    type="checkbox"
    @update:open="emit('update:open', $event)"
  />
</template>

<script setup>
// Libraries
import { computed, ref } from "vue";

// Components
import { Combobox } from "@/SharedComponents/Filters/Combobox";

// Composables
import { useTags } from "@/Composables/useTags";
import { useI18n } from "vue-i18n";

// Emits
const emit = defineEmits(["update:open"]);

// Props
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  tenant: {
    type: Array,
    required: true,
  },
});

// Refs
const tenant = ref(props.tenant ?? []);
const handle = ref("tag");

// Imported functions
const { t } = useI18n();
const { isLoading, data } = useTags(tenant.value);

// Computed props
const tags = computed(() => {
  if (isLoading.value) {
    return [
      {
        options: [],
      },
    ];
  }

  return [
    {
      options: [
        {
          id: "no_tags",
          name: t("components.filters.tags.no_tags"),
        },
      ]
        .concat(data.value)
        .map((tag) => {
          let { name, ...other } = tag;
          return { label: name, ...other };
        }),
    },
  ];
});
</script>
